/**
 * Bond Custody-Provider Enumerator.
 *
 * imported from
 * https://bitbucket.org/exporodev/exporo_trading_platform/src/master/application/Exporo/Trading/src/Datatypes/Enums/Bonds/CustodyType.php
 */

export const CustodyTypesEnum = {
  CLEARSTREAM: 'clearstream',
  ETHEREUM: 'ethereum',
};

export const CustodyProviders = {
  BAADERBANK: { text: 'Baader Bank', value: 'baaderbank' },
  UPVEST: { text: 'Upvest', value: 'upvest' },
  TANGANY: { text: 'Tangany', value: 'tangany' },
};

export default CustodyTypesEnum;
